import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Shadcn Table sub-components with cva variant support for density.
 * Exports Table, TableHeader, TableBody, TableFooter, TableRow,
 * TableHead, TableCell, and TableCaption. TableHead and TableCell
 * accept a variant prop ("default" | "dense") for sub-table styling.
 */
import { cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "./utils.js";
const Table = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { className: "relative w-full overflow-auto", children: _jsx("table", { ref: ref, className: cn("w-full caption-bottom text-sm", className), ...props }) })));
Table.displayName = "Table";
const TableHeader = React.forwardRef(({ className, ...props }, ref) => (_jsx("thead", { ref: ref, className: cn("[&_tr]:border-b", className), ...props })));
TableHeader.displayName = "TableHeader";
const TableBody = React.forwardRef(({ className, ...props }, ref) => (_jsx("tbody", { ref: ref, className: cn("[&_tr:last-child]:border-0", className), ...props })));
TableBody.displayName = "TableBody";
const TableFooter = React.forwardRef(({ className, ...props }, ref) => (_jsx("tfoot", { ref: ref, className: cn("border-t bg-muted/50 font-medium [&>tr]:last:border-b-0", className), ...props })));
TableFooter.displayName = "TableFooter";
const TableRow = React.forwardRef(({ className, ...props }, ref) => (_jsx("tr", { ref: ref, className: cn("border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted", className), ...props })));
TableRow.displayName = "TableRow";
const tableHeadVariants = cva("text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]", {
    variants: {
        variant: {
            default: "h-10 px-2",
            dense: "h-8 px-3 py-1.5 text-xs",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});
const TableHead = React.forwardRef(({ className, variant, ...props }, ref) => (_jsx("th", { ref: ref, className: cn(tableHeadVariants({ variant }), className), ...props })));
TableHead.displayName = "TableHead";
const tableCellVariants = cva("align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]", {
    variants: {
        variant: {
            default: "p-2",
            dense: "px-3 py-1.5 text-xs",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});
const TableCell = React.forwardRef(({ className, variant, ...props }, ref) => (_jsx("td", { ref: ref, className: cn(tableCellVariants({ variant }), className), ...props })));
TableCell.displayName = "TableCell";
const TableCaption = React.forwardRef(({ className, ...props }, ref) => (_jsx("caption", { ref: ref, className: cn("mt-4 text-sm text-muted-foreground", className), ...props })));
TableCaption.displayName = "TableCaption";
export { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption, };
//# sourceMappingURL=table.js.map